// to handle GS bug EC-2163
export const getGSRepetitionRate = (rate?: number | string): undefined | string => {
    if (!rate) return undefined;
    return rate.toString().replaceAll(',', '.');
};
